<script>
    import ClassName from './ClassNameComponent.svelte';
    import TeacherName from './TeacherNameComponent.svelte';
    import TimeShower from './TimeShowerComponent.svelte';
    import SendEmailLink from './RecieveEmailComponent.svelte';
    import ButtonToJoinClass from './ButtonToJoinClassComponent.svelte'
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import ButtonToJoinClassComponent from './ButtonToJoinClassComponent.svelte';
    import FilterButtons from './FilterButtons.svelte';
    import RescheduleButton from './ButtonToRescheduleComponent.svelte'
    import ButtonToComment from './ButtonToLeaveCommentComponent.svelte'
    import NavBarReusable from './NavbarReusable.svelte';
    import RescheduleRequestsContent from './RescheduleRequestsContent.svelte';
    import TeacherRegistrationRequestsComponent from './TeacherRegistrationRequestsComponent.svelte';
    import StudentsWithGradesComponent from './StudentsWithGradesComponent.svelte';
    import { getApiBase } from './apiBase.js';
    
    export let studentId = null;
    export let embedded = false;
    let lastEmbeddedStudentId = null;
    const apiBase = getApiBase();

    function getHashQueryParam(name) {
        const hash = window.location.hash || '';
        const qIndex = hash.indexOf('?');
        if (qIndex === -1) return null;
        const params = new URLSearchParams(hash.slice(qIndex + 1));
        return params.get(name);
    }

    // Student selection variables (from AdminStudentInvoiceViewer)
    let allStudents = [];
    let selectedStudentId = null;
    let selectedStudent = null;
    let selectedUserIsTeacher = false; // Track if selected user is a teacher
    let isLoadingStudents = true;
    let studentsError = null;
    let studentQuery = '';
    let filteredStudents = [];
    let showStudentDropdown = false;
    
    // Schedule variables (from Schedule.svelte)
    let events = [];
    let currentFilter = 'past_classes';
    let isUserTeacher = false;
    let activeTab = 'schedule'; // 'schedule', 'reschedule-requests', or 'registration-requests'
    let unacceptedRequestsCount = 0;
    let unacceptedRescheduleRequestsCount = 0;
    
    // Admin-specific variables
    let isLoadingSchedule = false;
    let scheduleError = null;
    let backLinkUrl = "/admin"; // Back to admin page

    // If opened via Students dashboard deep link, make Back return there
    $: if (!embedded && getHashQueryParam('studentId')) {
        backLinkUrl = "/admin/students";
    }
    
    // Function to switch between tabs
    function switchTab(tab) {
        activeTab = tab;
        // Refresh counts when switching away from specific tabs
        if (tab !== 'registration-requests' && selectedUserIsTeacher) {
            fetchUnacceptedRequestsCount();
        }
        if (tab !== 'reschedule-requests') {
            fetchUnacceptedRescheduleRequestsCount();
        }
    }

    // Function to fetch unaccepted registration requests count
    const fetchUnacceptedRequestsCount = async () => {
        if (!selectedUserIsTeacher || !selectedStudentId) return;
        
        const token = localStorage.getItem('jwtToken');
        try {
            const response = await fetch(`${apiBase}/studentplayground/api/teacher/class-registration-requests/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                let count = 0;
                
                // Count unaccepted requests across all days
                Object.values(data).forEach(dayRequests => {
                    dayRequests.forEach(req => {
                        if (!req.accepted_by_teacher) {
                            count++;
                        }
                    });
                });
                
                unacceptedRequestsCount = count;
            }
        } catch (error) {
            console.error('Error fetching registration requests count:', error);
        }
    };

    // Function to fetch unaccepted reschedule requests count
    const fetchUnacceptedRescheduleRequestsCount = async () => {
        if (!selectedStudentId) return;
        
        const token = localStorage.getItem('jwtToken');
        try {
            const response = await fetch(`${apiBase}/studentplayground/api/reschedule-requests-count/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                unacceptedRescheduleRequestsCount = data.pending_count;
            }
        } catch (error) {
            console.error('Error fetching reschedule requests count:', error);
        }
    };

    // Function to change the link text when clicked
    function changeLinkText(event) {
        const link = event.target;
        link.textContent = "Pamokos informacija išsiųsta!";
    }

    function isPastEvent(eventTime) {
        console.log("THis is the event time RAW");
        console.log(eventTime);
        
        // Format the event time to get the CLASS END TIME (not start time)
        const validEventTime = formatEventTime(eventTime)
        
        console.log("Event END time formatted:", validEventTime);
        
        if (!validEventTime) {
            console.error("Could not parse event time:", eventTime);
            return false; // Default to not past if we can't parse
        }
        
        try {
            // Parse the Lithuanian time string and create Date objects in Lithuanian timezone
            const [datePart, timePart] = validEventTime.split('T');
            
            // Create event date by treating the input as Lithuanian timezone
            // We need to parse it and then convert to UTC for accurate comparison
            const eventDateTime = new Date(validEventTime);
            
            // The key insight: the backend provides time in Lithuanian timezone, 
            // but JavaScript Date constructor treats it as local timezone
            // So we need to adjust for the difference
            
            // Get current time in Lithuanian timezone
            const now = new Date();
            const nowInLithuaniaStr = now.toLocaleString("sv-SE", { timeZone: "Europe/Vilnius" });
            const nowInLithuania = new Date(nowInLithuaniaStr);
            
            // Create event time in Lithuanian timezone using the same method
            const eventInLithuaniaStr = validEventTime.replace('T', ' ');
            const eventInLithuania = new Date(eventInLithuaniaStr);
            
            // Add 10-minute buffer for both teachers and students - they can leave comments 10 minutes before class ends
            // This allows both to submit feedback if they finish early
            const bufferMinutes = 10; // Apply 10-minute buffer for everyone
            const eventWithBuffer = new Date(eventInLithuania.getTime() - (bufferMinutes * 60 * 1000));
            
            // Since both are now in the same reference frame, we can compare directly
            console.log("Event END time (Lithuanian interpreted):", eventInLithuania);
            console.log("Event END time with buffer:", eventWithBuffer);
            console.log("Current time (Lithuanian interpreted):", nowInLithuania);
            console.log("Is past event (class ended + buffer):", eventWithBuffer < nowInLithuania);

            // Check if the event is in the past (considering the 10-minute buffer for everyone)
            return eventWithBuffer < nowInLithuania;
            
        } catch (error) {
            console.error("Error parsing event time:", error);
            return false; // Default to not past if parsing fails
        }
    }

    const formatDateTime = (datetime) => {
        let parts = datetime.split(" ");
        let datePart = parts[0];
        let timePart = parts[1];
        let dayPart = parts[2];

        let formattedDate = `${dayPart}<br>${datePart}`;
        return { timePart, formattedDate };
    };

    function formatEventTime(eventTime) {
        // Extract the date and time parts using a regular expression
        const match = eventTime.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);

        if (!match) {
            console.error("Invalid date format:", eventTime);
            return null; // Return null if the format doesn't match the expected pattern
        }

        const datePart = match[1]; // e.g., "2024-09-06"
        const timePart = match[2]; // e.g., "14:00"

        // FIXED: Since displayTime contains START time, but we need to check END time,
        // add 1 hour to get the actual class end time
        const [hours, minutes] = timePart.split(':').map(Number);
        const startTime = new Date(`${datePart}T${timePart}:00`);
        const endTime = new Date(startTime.getTime() + (60 * 60 * 1000)); // Add 1 hour
        
        // Format back to ISO string format for consistency
        const endHours = endTime.getHours().toString().padStart(2, '0');
        const endMinutes = endTime.getMinutes().toString().padStart(2, '0');
        
        return `${datePart}T${endHours}:${endMinutes}:00`;
    }

    const fetchUserRole = async () => {
        const token = localStorage.getItem('jwtToken')
        console.log("This is the token:)")
        console.log(token)
        try {
            const response = await fetch(`${apiBase}/studentplayground/isUserTeacher/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                isUserTeacher = data.isUserTeacher
                console.log("THis is what returns for isUserTeacher:")
                console.log(isUserTeacher)// Assuming the role is returned in the JSON as { "role": "Teacher" }
            } else {
                if (response.status === 401) {
                    // If response is 401 Unauthorized, redirect to login
                    alert('Reikia prisijungti iš naujo.');
                    localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                    window.location.href = '#/about'; // Redirect to login page
                } else {
                    // Handle other errors
                    alert('Error submitting form!');
                }
            }
        } catch (error) {
            console.error("Failed to fetch user role:", error);
            return null;
        }
    };

    const fetchEvents = async () => {
        if (!selectedStudentId) {
            console.error('No user selected for schedule fetch');
            return;
        }

        const token = localStorage.getItem('jwtToken'); // Retrieve token from localStorage

        if (!token) {
            console.error('No JWT token found. User might not be logged in.');
            scheduleError = 'Nepavyko rasti autentifikacijos duomenų.';
            return;
        }

        isLoadingSchedule = true;
        scheduleError = null;

        try {
            const userType = selectedUserIsTeacher ? 'teacher' : 'student';
            console.log(`📅 ADMIN DEBUG - Fetching schedule for ${userType}:`, selectedStudentId);
            console.log("Selected user is teacher:", selectedUserIsTeacher);
            console.log("Logged-in user is teacher:", isUserTeacher);
            
            // Use different endpoints based on whether selected user is a teacher or student
            const url = selectedUserIsTeacher
                ? `${apiBase}/studentplayground/admin/debug-teacher-schedule/${selectedStudentId}/?filter=${currentFilter}`
                : `${apiBase}/studentplayground/admin/debug-schedule/${selectedStudentId}/?filter=${currentFilter}`;

            console.log("THis is the url we trynna get to:")
            console.log(url)

            // Make the request
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                events = data.events;
                console.log("📅 ADMIN DEBUG - Loaded events:", events.length);
                scheduleError = null;
            } else {
                if (response.status === 401) {
                    // If response is 401 Unauthorized, redirect to login
                    alert('Reikia prisijungti iš naujo.');
                    localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                    window.location.href = '#/about'; // Redirect to login page
                } else {
                    // Handle other errors
                    const error = await response.json();
                    scheduleError = error.message || 'Nepavyko gauti tvarkaraščio duomenų.';
                }
            }
        } catch (error) {
            console.error("Failed to fetch events:", error);
            scheduleError = 'Tinklo klaida. Patikrinkite interneto ryšį.';
        } finally {
            isLoadingSchedule = false;
        }
    };

    // Handle filter change event from FilterButtons component
    const handleFilterChange = (event) => {
        currentFilter = event.detail.filter; // Update the filter
        fetchEvents(); // Fetch new events based on the filter
    };

    // Student selection functions (from AdminStudentInvoiceViewer)
    async function fetchAllStudents() {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
            console.error('No JWT token found. User might not be logged in.');
            studentsError = 'Nepavyko rasti autentifikacijos duomenų.';
            isLoadingStudents = false;
            return;
        }

        try {
            const response = await fetch(`${apiBase}/studentplayground/admin/get-all-students/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const result = await response.json();
                allStudents = result.students || [];
                filteredStudents = allStudents;
                console.log('👥 ADMIN DEBUG - Loaded students:', allStudents.length);
                studentsError = null;
            } else {
                const error = await response.json();
                console.log('Error fetching students:', error);
                studentsError = error.message || 'Nepavyko gauti studentų sąrašo.';
            }
        } catch (error) {
            console.log('Fetch error:', error);
            studentsError = 'Tinklo klaida. Patikrinkite interneto ryšį.';
        } finally {
            isLoadingStudents = false;
        }
    }

    function selectStudent(student) {
        selectedStudent = student;
        selectedStudentId = student.id;
        selectedUserIsTeacher = student.is_teacher || false; // Set whether selected user is a teacher
        studentQuery = `${student.first_name} ${student.last_name}`;
        showStudentDropdown = false;
        
        const userType = selectedUserIsTeacher ? 'teacher' : 'student';
        console.log(`👤 ADMIN DEBUG - Selected ${userType}:`, selectedStudent);
        
        // Reset schedule data when changing student
        events = [];
        scheduleError = null;
        
        // Reset counts
        unacceptedRequestsCount = 0;
        unacceptedRescheduleRequestsCount = 0;
        
        // Fetch schedule data for selected student/teacher
        fetchEvents();
        
        // Fetch counts if SELECTED user is a teacher (not logged-in user)
        if (selectedUserIsTeacher) {
            fetchUnacceptedRequestsCount();
        }
        fetchUnacceptedRescheduleRequestsCount();
    }

    function filterStudents() {
        if (!studentQuery.trim()) {
            filteredStudents = allStudents;
            showStudentDropdown = false;
        } else {
            const query = studentQuery.toLowerCase();
            filteredStudents = allStudents.filter(student => 
                `${student.first_name} ${student.last_name}`.toLowerCase().includes(query) ||
                student.email.toLowerCase().includes(query)
            );
            showStudentDropdown = !selectedStudent && filteredStudents.length > 0;
        }
    }

    function clearStudentSelection() {
        selectedStudent = null;
        selectedStudentId = null;
        selectedUserIsTeacher = false;
        studentQuery = '';
        showStudentDropdown = false;
        filteredStudents = allStudents;
        
        // Reset schedule data
        events = [];
        scheduleError = null;
        unacceptedRequestsCount = 0;
        unacceptedRescheduleRequestsCount = 0;
    }

    // Fetch user role and students when component mounts
    onMount(async () => {
        await fetchUserRole();
        console.log("THis is teacher value:D")
        console.log(isUserTeacher)
        if (embedded && studentId) {
            const idNum = typeof studentId === 'string' ? parseInt(studentId, 10) : studentId;
            if (!Number.isNaN(idNum)) {
                lastEmbeddedStudentId = idNum;
                selectedStudentId = idNum;
                selectedStudent = null;
                selectedUserIsTeacher = false;
                isLoadingStudents = false;
                studentsError = null;
                await fetchEvents();
                return;
            }
        }

        await fetchAllStudents();

        // Full-page deep link support: #/admin/student-schedule-debug?studentId=123
        const fromQuery = getHashQueryParam('studentId');
        if (fromQuery) {
            const idNum = parseInt(fromQuery, 10);
            if (!Number.isNaN(idNum) && allStudents && allStudents.length > 0) {
                const match = allStudents.find(s => s.id === idNum);
                if (match) {
                    selectStudent(match);
                } else {
                    selectedStudentId = idNum;
                    selectedStudent = null;
                    selectedUserIsTeacher = false;
                    fetchEvents();
                }
            }
        }
    });

    $: if (embedded && studentId) {
        const idNum = typeof studentId === 'string' ? parseInt(studentId, 10) : studentId;
        if (!Number.isNaN(idNum) && idNum !== lastEmbeddedStudentId) {
            lastEmbeddedStudentId = idNum;
            selectedStudentId = idNum;
            selectedStudent = null;
            selectedUserIsTeacher = false;
            events = [];
            scheduleError = null;
            fetchEvents();
        }
    }

    // Reactive statement to filter students when search query changes
    $: if (studentQuery !== undefined) {
        filterStudents();
    }
</script>

<style>
    /* Import schedule styles from Schedule.svelte */
    .classcontainer{
        padding: 15px;
        background-color: #eeebdb;
        display: flex;
        flex-direction: column;
        margin-bottom:15px;
        gap: 10px;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        flex: none;
        color:black;
        align-items: flex-start;
    }

    .no-classes-message {
        padding: 30px;
        text-align: center;
        background-color: #f8f9fa;
        border-radius: 8px;
        margin: 20px 0;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
    }

    .no-classes-message p {
        color: #6c757d;
        font-size: 16px;
        margin: 0;
        font-weight: 500;
    }

    .reschedule-tab {
        width: 100%;
        margin-top: 10px;
    }

    .reschedule-tab-button {
        width: 100%;
        padding: 15px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        transition: background-color 0.3s, color 0.3s;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        position: relative;
    }

    .reschedule-tab-button.active {
        background-color: #fab45a;
        color: black;
        border-color: #fab45a;
    }

    .reschedule-tab-button:hover {
        background-color: #fab45a;
        color: black;
    }

    .teacher-registration-tab {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .teacher-registration-button {
        width: 100%;
        padding: 15px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        transition: background-color 0.3s, color 0.3s;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        position: relative;
    }

    .teacher-registration-button:hover {
        background-color: #fab45a;
        color: black;
    }

    .count-badge {
        background-color: #dc3545;
        color: white;
        border-radius: 50%;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: bold;
        min-width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }

    /* Admin-specific styles (from AdminStudentInvoiceViewer) */
    .admin-header {
        background-color: #dc3545;
        color: white;
        padding: 1rem;
        margin-bottom: 2rem;
        border-radius: 8px;
        text-align: center;
    }

    .admin-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0 0 0.5rem 0;
    }

    .admin-subtitle {
        font-size: 1rem;
        margin: 0;
        opacity: 0.9;
    }

    .student-selector {
        margin-bottom: 2rem;
        padding: 1.5rem;
        background-color: #f8f9fa;
        border-radius: 8px;
        border-left: 4px solid #dc3545;
    }

    .student-selector label {
        color: #dc3545;
        font-size: 1.2rem;
        margin-bottom: 1rem;
        display: block;
    }

    .input-container {
        position: relative;
        margin-top: 15px;
    }

    .search-input {
        width: 100%;
        padding: 12px;
        border: 2px solid #ddd;
        border-radius: 6px;
        font-size: 1rem;
        background-color: white;
    }

    .search-input:focus {
        outline: none;
        border-color: #dc3545;
        box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
    }

    .autocomplete-list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ddd;
        border-top: none;
        border-radius: 0 0 6px 6px;
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        list-style: none;
        padding: 0;
        margin: 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .autocomplete-list li {
        border-bottom: 1px solid #f0f0f0;
    }

    .autocomplete-list li:last-child {
        border-bottom: none;
    }

    .autocomplete-list button {
        width: 100%;
        padding: 12px;
        border: none;
        background: none;
        text-align: left;
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .autocomplete-list button:hover {
        background-color: #f8f9fa;
    }

    .student-option {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .student-name {
        font-weight: 500;
        color: #333;
        font-size: 0.9em;
    }

    .student-email {
        color: #666;
        font-size: 0.8em;
    }

    .student-id {
        color: #dc3545;
        font-size: 0.75em;
        font-weight: 500;
    }

    .selected-student-info {
        margin-top: 1rem;
        padding: 1rem;
        background-color: white;
        border-radius: 4px;
        border: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 15px;
    }

    .selected-student-details {
        flex: 1;
    }

    .student-info-label {
        font-weight: 600;
        color: #dc3545;
    }

    .btn-clear-selection {
        padding: 8px 16px;
        background-color: #6c757d;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 0.85em;
        white-space: nowrap;
        transition: background-color 0.2s;
    }

    .btn-clear-selection:hover {
        background-color: #545b62;
    }

    .debug-warning {
        background-color: #fff3cd;
        border: 1px solid #ffeaa7;
        border-left: 4px solid #f39c12;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 4px;
    }

    .debug-warning-title {
        font-weight: bold;
        color: #856404;
        margin-bottom: 0.5rem;
    }

    .debug-warning-text {
        color: #856404;
        margin: 0;
    }

    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        margin: 2rem 0;
    }

    .loading-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #14695b;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 1rem;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-text {
        color: #666;
        font-size: 1rem;
        margin: 0;
    }

    .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        margin: 2rem 0;
        background-color: #fff3f3;
        border-radius: 8px;
        border-left: 4px solid #dc3545;
    }

    .error-text {
        color: #dc3545;
        font-size: 1rem;
        margin-bottom: 1rem;
        text-align: center;
    }

    .error-container button {
        background-color: #dc3545;
        color: white;
        border: none;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        cursor: pointer;
        font-size: 0.9rem;
    }

    .error-container button:hover {
        background-color: #c82333;
    }
</style>

{#if !embedded}
<NavBarReusable label="Admin: Schedule Debug" backLink={backLinkUrl} />

<div class="admin-header">
    <h1 class="admin-title">📅 Admin Debug: User Schedule Viewer</h1>
    <p class="admin-subtitle">View any student or teacher's schedule page exactly as they see it</p>
</div>

<div class="debug-warning">
    <div class="debug-warning-title">⚠️ Debug Mode Active</div>
    <p class="debug-warning-text">This is an admin debugging tool. Interactive functionality (joining classes, rescheduling) is disabled. You're seeing the exact view that the selected user (student or teacher) would see.</p>
</div>

<!-- Student Selection -->
<div class="student-selector">
    <label for="student-search">Select User to Debug:</label>
    
    {#if isLoadingStudents}
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">Loading students...</p>
        </div>
    {:else if studentsError}
        <div class="error-container">
            <p class="error-text">Error: {studentsError}</p>
            <button on:click={() => { isLoadingStudents = true; studentsError = null; fetchAllStudents(); }}>
                Try Again
            </button>
        </div>
    {:else}
        <div class="input-container">
            <input 
                id="student-search"
                type="text" 
                placeholder="Search user by name or email..."
                bind:value={studentQuery}
                on:input={() => {
                    if (selectedStudent && studentQuery !== `${selectedStudent.first_name} ${selectedStudent.last_name}`) {
                        selectedStudent = null;
                        selectedStudentId = null;
                        showStudentDropdown = true;
                    } else if (!selectedStudent) {
                        showStudentDropdown = studentQuery.trim().length > 0;
                    }
                }}
                autocomplete="off"
                class="search-input"
            />
            
            {#if showStudentDropdown}
                <ul class="autocomplete-list">
                    {#each filteredStudents.slice(0, 8) as student}
                        <li>
                            <button
                                type="button"
                                on:click={() => selectStudent(student)}
                                on:keydown={(e) => (e.key === 'Enter' || e.key === ' ') && selectStudent(student)}
                            >
                                <div class="student-option">
                                    <span class="student-name">
                                        {student.first_name} {student.last_name}
                                        {#if student.is_teacher}
                                            <span style="color: #28a745; font-size: 0.8em; margin-left: 5px;">👨‍🏫 Teacher</span>
                                        {/if}
                                    </span>
                                    <span class="student-email">{student.email}</span>
                                    <span class="student-id">ID: {student.id}</span>
                                </div>
                            </button>
                        </li>
                    {/each}
                </ul>
            {/if}
        </div>
        
        {#if selectedStudent}
            <div class="selected-student-info">
                <div class="selected-student-details">
                    <div>
                        <span class="student-info-label">Name:</span> {selectedStudent.first_name} {selectedStudent.last_name}
                        {#if selectedUserIsTeacher}
                            <span style="color: #28a745; font-weight: bold; margin-left: 8px;">👨‍🏫 Teacher</span>
                        {/if}
                    </div>
                    <div><span class="student-info-label">Email:</span> {selectedStudent.email}</div>
                    <div><span class="student-info-label">ID:</span> {selectedStudent.id}</div>
                </div>
                <button 
                    type="button" 
                    class="btn-clear-selection" 
                    on:click={clearStudentSelection}
                >
                    Clear Selection
                </button>
            </div>
        {/if}
    {/if}
</div>
{/if}

<!-- Student Schedule View (identical to Schedule.svelte but with admin modifications) -->
{#if selectedStudentId}
    {#if isLoadingSchedule}
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">Loading student schedule...</p>
        </div>
    {:else if scheduleError}
        <div class="error-container">
            <p class="error-text">Error: {scheduleError}</p>
            <button on:click={() => { isLoadingSchedule = true; scheduleError = null; fetchEvents(); }}>
                Try Again
            </button>
        </div>
    {:else}
        <!-- Teacher registration button - shown only for teachers -->
        {#if selectedUserIsTeacher && activeTab === 'schedule'}
            <div class="teacher-registration-tab">
                <button 
                    class="teacher-registration-button"
                    on:click={() => switchTab('registration-requests')}
                >
                    <span>KLASIŲ REGISTRACIJOS</span>
                    {#if unacceptedRequestsCount > 0}
                        <span class="count-badge">{unacceptedRequestsCount}</span>
                    {/if}
                </button>
            </div>
        {/if}

        {#if activeTab === 'schedule'}
            <FilterButtons 
                currentFilter={currentFilter} 
                on:filterChange={handleFilterChange} />
        {/if}

        {#if activeTab !== 'registration-requests'}
            <div class="reschedule-tab">
                <button 
                    class="reschedule-tab-button {activeTab === 'reschedule-requests' ? 'active' : ''}"
                    on:click={() => switchTab(activeTab === 'reschedule-requests' ? 'schedule' : 'reschedule-requests')}
                >
                    <span>{activeTab === 'reschedule-requests' ? 'ATGAL Į TVARKARAŠTĮ' : 'PAMOKŲ PAKEITIMAI'}</span>
                    {#if unacceptedRescheduleRequestsCount > 0 && activeTab !== 'reschedule-requests'}
                        <span class="count-badge">{unacceptedRescheduleRequestsCount}</span>
                    {/if}
                </button>
            </div>
        {/if}

        <!-- Back button for registration requests -->
        {#if activeTab === 'registration-requests'}
            <div class="reschedule-tab">
                <button 
                    class="reschedule-tab-button active"
                    on:click={() => switchTab('schedule')}
                >
                    ATGAL Į TVARKARAŠTĮ
                </button>
            </div>
        {/if}

        {#if activeTab === 'schedule'}
            <div class="classSection">
                {#if events.length === 0}
                    <div class="no-classes-message">
                        <p>Pamokų nerasta</p>
                    </div>
                {:else}
                    {#each events as event}
                        <div class="classcontainer {isPastEvent(event.laikasDisp) ? 'past-event' : 'upcoming-event'}">
                            <!-- Render the class details -->
                            <ClassName name={event.pamoka} />
                            <TeacherName teacher={event.mokytojas}/>
                            <TimeShower 
                                time={formatDateTime(event.laikasDisp).timePart} 
                                date={formatDateTime(event.laikasDisp).formattedDate} 
                            />
                            
                            <!-- Show students with grades for teachers -->
                            {#if selectedUserIsTeacher && event.students}
                                <StudentsWithGradesComponent students={event.students} />
                            {/if}
                
                            {#if isPastEvent(event.laikasDisp)}
                                <!-- Render components for past events -->
                                
                                {#if event.note === 'nėra atsiliepimo' || !event.note}
                                    <ButtonToComment classId={event.id}  label="Palikti Atsiliepimą (Debug)"></ButtonToComment>
                                {:else}
                                    <ButtonToComment classId={event.id} label="Koreguoti Atsiliepimą (Debug)" buttonClass="koregouti"></ButtonToComment>
                                {/if}
                            {:else}
                                <!-- Render components for upcoming events with admin modifications -->
                                
                                <ButtonToJoinClass 
                                    link={event.nuoroda} 
                                    classId={event.id}
                                    label="Jungtis į pamoką" 
                                />
                                <button 
                                    style="background-color: #6c757d; cursor: not-allowed;"
                                    disabled
                                >
                                    🚫 Reschedule (Debug Mode)
                                </button>
                            {/if}
                        </div>
                    {/each}
                {/if}
            </div>
        {:else if activeTab === 'reschedule-requests'}
            <RescheduleRequestsContent />
        {:else if activeTab === 'registration-requests'}
            <TeacherRegistrationRequestsComponent />
        {/if}
    {/if}
{:else}
    <div class="loading-container">
        <p class="loading-text">👆 Please select a user above to view their schedule</p>
    </div>
{/if}
